// Vendors
import PropTypes from 'prop-types';

// Assets
import { ReactComponent as UserIcon } from '../../assets/user.svg';
import { ReactComponent as EmailIcon } from '../../assets/email.svg';
import { ReactComponent as PhoneIcon } from '../../assets/phone.svg';
import { ReactComponent as HomeIcon } from '../../assets/home.svg';
import { ReactComponent as ErrorLockedOutIcon } from '../../assets/Error_LockedOut.svg';
import { ReactComponent as EyeIcon } from '../../assets/eye.svg';
import { ReactComponent as EyeOffIcon } from '../../assets/eye-off.svg';
import { ReactComponent as ChevronDownIcon } from '../../assets/chevron-down.svg';
import { ReactComponent as ChevronLeftIcon } from '../../assets/chevron-left.svg';
import { ReactComponent as TickIcon } from '../../assets/tick.svg';
import { ReactComponent as StateOfTexasIcon } from '../../assets/txt-footer-logo.svg';

export const icons = {
  user: UserIcon,
  email: EmailIcon,
  phone: PhoneIcon,
  home: HomeIcon,
  errorLockedOut: ErrorLockedOutIcon,
  eye: EyeIcon,
  eyeOff: EyeOffIcon,
  chevronDown: ChevronDownIcon,
  chevronLeft: ChevronLeftIcon,
  tick: TickIcon,
  stateOfTexas: StateOfTexasIcon,
};

const Icon = ({ name, className, ...props }) => {
  if (!name || !icons[name]) return null;

  const IconComponent = icons[name];

  return (
    <IconComponent
      {...props}
      className={className}
      role="presentation"
    />
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Icon;
